import type { ComponentsOverrides, ComponentsVariants, ComponentsProps } from '@mui/material';
import type { Hero_BaseFragmentFragment } from '@ias/graphql-sdk';
import { type LinkProps } from '../Link';

export enum HeroVariants {
  default = 'default',
  simple = 'simple',
  mediaOnRight = 'mediaOnRight',
  mediaOnRightFullBleed = 'mediaOnRightFullBleed',
  mediaOnLeft = 'mediaOnLeft',
  mediaOnLeftFullBleed = 'mediaOnLeftFullBleed',
  mediaBelow = 'mediaBelow',
  mediaAbove = 'mediaAbove',
  mediaSmall = 'mediaSmall',
  news = 'news',
  imageOnly = 'imageOnly',
  alignLeft = 'Align - Left',
  alignCenter = 'Align - Center'
}

export interface HeroProps extends Omit<Hero_BaseFragmentFragment, 'variant'> {
  variant: HeroVariants;
  breadcrumbs?: LinkProps[];
  showFullImage?: boolean;
  isHomepage?: boolean;
  hideBreadcrumbs?: boolean;
  overline?: string;
}

export interface HeroOwnerState extends HeroProps {}

interface HeroClasses {
  root: string;
  backgroundGrid: string;
  contentOuterGrid: string;
  contentInnerWrapper: string;
  mainContentWrap: string;
  bottomContentWrap: string;
  sideContentWrap: string;
  content: string;
  background: string;
  overline: string;
  title: string;
  subtitle: string;
  body: string;
  mediaWrap: string;
  media: string;
  actionsWrap: string;
  action: string;
  breadcrumbsWrap: string;
  contentInnerWrap: string;
  scrollToContentWrap: string;
}

export declare type HeroClassKey = keyof HeroClasses;

declare module '@mui/material' {
  export interface ComponentNameToClassKey {
    Hero: HeroClassKey;
  }

  export interface ComponentsPropsList {
    Hero: HeroProps;
  }
}

declare module '@mui/material' {
  interface Components {
    Hero?: {
      defaultProps?: ComponentsProps['Hero'];
      styleOverrides?: ComponentsOverrides['Hero'];
      variants?: ComponentsVariants['Hero'];
    };
  }
}
